<template>
  <!-- 优惠券 -->
  <div class="coupon_item_c flex-start">
    <div class="left">
      <div class="num">
        <span v-if="data.type.indexOf('minus') > -1">¥</span>
        <span class="rate">
          {{Number(data.rate)}}
          <span v-if="data.type.indexOf('discount') > -1" class="zhe">折</span>
        </span>
      </div>
      <div v-if="data.type.indexOf('amount') > -1">满{{Number(data.amount)}}元可用</div>
      <div v-else>{{categoryByType.typeLimit}}</div>
    </div>
    <div class="right">
      <div class="title">{{categoryByType.targetType}}优惠券</div>
      <div class="date">
        <span v-if="data.deadline">有效期至：{{deadline}}</span>
        <span v-else>长期有效</span>
      </div>
      <div class="coupon-btn-wrap">
        <div class="coupon-btn flex-center" v-if="data.usableStatus == 'ok'" @click="toUse">去使用</div>
        <div class="coupon-btn flex-center" v-if="data.usableStatus == 'ok' && categoryByType.outline && !action" @click="useOutline">线下使用</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
export default {
  props: {
    data: {},
    action: '' // 是否正在使用优惠券
  },
  data() {
    return {
    }
  },
  computed: {
    categoryByType() {
      let type = this.data.targetType;
      switch (type) {
        case 'course':
          return {
            typeLimit: '购买课程可用',
            targetType: '课程',
            toName: 'home',
            src: ''
          };
          break;
        case 'vip':
          return {
            typeLimit: '购买会员可用',
            targetType: '会员',
            toName: 'vip',
            src: ''
          };
          break;
        case 'product':
          return {
            typeLimit: '活动可用',
            targetType: '活动',
            toName: '',
            src: ''
          };
          break;
        case 'clubGroupCourse':
          return {
            typeLimit: '购买团课可用',
            targetType: '俱乐部团课',
            outline: true,
            toName: '',
            src: '/venue'
          };
          break;
        case 'clubMonthCard':
          return {
            typeLimit: '购买月卡可用',
            targetType: '俱乐部月卡',
            outline: true,
            toName: '',
            src: '/venue'
          };
          break;
        case 'clubPracticeCard':
          return {
            typeLimit: '购买练球卡可用',
            targetType: '练球卡',
            outline: true,
            toName: '',
            src: '/venue'
          };
          break;
        case 'clubPtCourse':
          return {
            typeLimit: '购买私教课可用',
            targetType: '私教课',
            outline: true,
            toName: '',
            src: '/venue'
          };
          break;
        case 'gradingLevelVerify':
          return {
            typeLimit: '等级认证可用',
            targetType: '等级认证',
            toName: 'levelVerify',
            src: ''
          };
          break;
        case 'gradingLevelAimUnlock':
          return {
            typeLimit: '训练解锁可用',
            targetType: '训练解锁',
            toName: 'trainingHome',
            src: ''
          };
          break;
        case 'application':
          return {
            typeLimit: '应用购买可用',
            targetType: '应用购买',
            toName: '',
            src: ''
          };
          break;
        case 'all':
          return {
            typeLimit: '无使用门槛',
            targetType: '万能',
            outline: true,
            toName: 'home',
            src: ''
          };
          break;
        default:
          return {
            typeLimit: '特殊类型',
            targetType: '特殊类型',
            outline: true,
            toName: '',
            src: ''
          };
      }
    },
    deadline: function () {
      return moment(this.data.deadline*1000).format('YYYY-MM-DD')
    }
  },
  methods: {
    toUse() {
      if (this.action == 'use') {
        this.$emit('confirm', this.data);
      } else {
        if (this.categoryByType.toName) {
          this.$router.push({name: this.categoryByType.toName})
        } else if (this.categoryByType.src) {
          location.href = location.origin + this.categoryByType.src
        }
      }
    },
    useOutline() {
      this.$emit('showCode', this.data)
    }
  }
}
</script>

<style lang="less">
.coupon_item_c {
  height: 1rem;
  width: 95%;
  margin: .1rem auto;
  background: #fff;
  border: .01rem solid #eee;
  border-radius: .05rem;
  color: #aaa;
  font-size: .12rem;
  position: relative;
}
.coupon_item_c .left {
    width: .9rem;
    position: relative;
    text-align: center;
}
.coupon_item_c .left .num {
      color: #56D176;
      font-size: .16rem;
      font-weight: 500;
}
.coupon_item_c .left .num .rate {
        font-size: .24rem;
}
.coupon_item_c .left .num .rate .zhe {
          font-size: .18rem;
}
.coupon_item_c .left:after {
      content: '';
      display: block;
      height: .4rem;
      border-left: .01rem solid #e0e0e0;
      position: absolute;
      right: 0;
      top: 50%;
      -webkit-transform: translateY(-50%);
              transform: translateY(-50%);
}
.coupon_item_c .right {
    -webkit-box-flex: 1;
        -ms-flex: 1;
            flex: 1;
    padding: 0 .1rem;
    position: relative;
}
.coupon_item_c .right .title {
      font-size: .15rem;
      color: #666;
      margin: .06rem 0;
      max-width: 1.8rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
}
.coupon_item_c .right .coupon-btn-wrap {
      position: absolute;
      right: .1rem;
      top: 50%;
      -webkit-transform: translateY(-50%);
              transform: translateY(-50%);
}
.coupon_item_c .right .coupon-btn-wrap .coupon-btn {
        width: .64rem;
        height: .24rem;
        color: #56D176;
        border: #56D176 .01rem solid;
        border-radius: .05rem;
        font-size: .14rem;
}
.coupon_item_c .right .coupon-btn-wrap .coupon-btn + .coupon-btn {
          margin-top: .1rem;
          background: #56D176;
          color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/CouponItem.vue